import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_QUALITY_SCORECARDS = `${URL_RETAILER_SCOPED}/quality-scorecards`
const URL_QUALITY_SCORECARDS_ADMIN_OVERVIEW = `${URL_APP_ADMIN}/quality-scorecards/overview`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'quality-scorecards'>
  | DashRouteType<'quality-scorecards-admin-overview'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'quality-scorecards': URL_QUALITY_SCORECARDS,
  'quality-scorecards-admin-overview': URL_QUALITY_SCORECARDS_ADMIN_OVERVIEW,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
